<template>
  <div>
    <div class="header">
      <div class="top_box">
        <!-- 顶部链接 -->
        <top-link></top-link>
        <!-- logo+搜索框 -->
        <el-row class="search_box">
          <el-col :span="14">
            <img src="../../../static/img/logo.png" alt class="logo" />
          </el-col>
          <el-col :span="10">
            <el-input placeholder="请输入关键词搜索" v-model="searchTxt" @keyup.enter.native="searchFun"></el-input>
            <input
              type="image"
              src="../../../static/img/search.png"
              class="search_btn"
              @click="searchFun"
            />
            <p class="nowTime">当前时间：{{ date | formaDate }}</p>
          </el-col>
        </el-row>
      </div>
      <!-- 导航栏 -->
      <nav-elem></nav-elem>
    </div>
  </div>
</template>
<script>
import topLink from "@/components/com/topLink";
import navElem from "@/components/com/nav";

var that;

var padaDate = function(value) {
  return value < 10 ? "0" + value : value;
};
export default {
  components: {
    "top-link": topLink,
    "nav-elem": navElem
  },
  data() {
    return {
      searchTxt: "",
      date: new Date()
    };
  },
  mounted() {
    that = this;
    //创建定时器更新时间
    that.timeId = setInterval(function() {
      that.date = new Date();
    }, 1000);
  },
  methods: {
    searchFun() {
      sessionStorage.setItem("searchScrollHei", 0);
      if (that.searchTxt == "") {
        alert("关键词不能为空");
      } else {
        console.log(that.searchTxt);
        if (that.$route.name == "search") {
          that.$router.replace({
            path: "search",
            query: { keywords: that.searchTxt }
          });
        } else {
          that.$router.push({
            path: "search",
            query: { keywords: that.searchTxt }
          });
        }
      }
    }
  },
  filters: {
    //获取当前时间
    //设置一个函数来进行过滤
    formaDate: function(value) {
      //创建一个时间日期对象
      var date = new Date();
      var year = date.getFullYear(); //存储年
      var month = padaDate(date.getMonth() + 1); //存储月份
      var day = padaDate(date.getDate()); //存储日期
      var week = date.getDay(); //存储周几
      console.log(week)
      var hours = padaDate(date.getHours()); //存储时
      var minutes = padaDate(date.getMinutes()); //存储分
      var seconds = padaDate(date.getSeconds()); //存储秒
      //换成星期几
      if (week == 1) {
        week = "一";
      } else if (week == 2) {
        week = "二";
      } else if (week == 3) {
        week = "三";
      } else if (week == 4) {
        week = "四";
      } else if (week == 5) {
        week = "五";
      } else if (week == 6) {
        week = "六";
      } else if (week == 7 || week == 0) {
        week = "日";
      }
      //返回格式化后的日期
      return (
        year +
        "年" +
        month +
        "月" +
        day +
        "日 " +
        "星期" +
        week +
        "  " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds
      );
    }
  },
  beforeDestroy: function() {
    //实例销毁前青出于定时器
    if (that.timeId) {
      clearInterval(that.timeId);
    }
  }
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/com/header.vue